import { func } from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

class Withdraw extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loading: false };
  }

  load(handler) {
    this.setState({ loading: true });
    Promise.resolve(handler()).finally(() => this.setState({ loading: false }));
  }

  render() {
    const { onWithdraw } = this.props;
    const { loading } = this.state;

    return (
      <Button
        size="sm"
        onClick={() => this.load(onWithdraw)}
        disabled={loading}
      >
        Withdraw
      </Button>
    );
  }
}
Withdraw.propTypes = {
  onWithdraw: func.isRequired,
};

export default Withdraw;
